import { createBrowserRouter } from 'react-router';
import { Layout } from '../components/Layout.js';
import { AuthGuard } from './guards.js';
import { LoginView } from '../features/auth/LoginView.js';
import { RegisterView } from '../features/auth/RegisterView.js';
import { LandingView } from '../features/landing/LandingView.js';
import { MapView } from '../features/spot-map/MapView.js';
import { SpotListView } from '../features/spot-list/SpotListView.js';
import { SpotDetailView } from '../features/spot-detail/SpotDetailView.js';
import { SpotRegistrationForm } from '../features/spot-registration/SpotRegistrationForm.js';
import { SpotEditForm } from '../features/spot-edit/SpotEditForm.js';
import { UserProfileView } from '../features/user-profile/UserProfileView.js';
import { UserCheckinListView } from '../features/user-profile/UserCheckinListView.js';
import { UserSpotListView } from '../features/user-profile/UserSpotListView.js';
import { FollowListView } from '../features/user-profile/FollowListView.js';
import { ReleaseNotesView } from '../features/release-notes/ReleaseNotesView.js';
import { HelpView } from '../features/help/HelpView.js';
import { FaqView } from '../features/faq/FaqView.js';
import { RankingView } from '../features/ranking/RankingView.js';
import { TimelineView } from '../features/timeline/TimelineView.js';
import { NotificationsView } from '../features/notifications/NotificationsView.js';
import { BookmarkListView } from '../features/bookmarks/BookmarkListView.js';
import { NotificationSettingsView } from '../features/notification-settings/NotificationSettingsView.js';
import { InboxView } from '../features/messages/InboxView.js';
import { ConversationView } from '../features/messages/ConversationView.js';
import { BlockListView } from '../features/block-list/BlockListView.js';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const router: any = createBrowserRouter([
  {
    path: '/landing',
    element: <LandingView />,
  },
  {
    path: '/login',
    element: <LoginView />,
  },
  {
    path: '/register',
    element: <RegisterView />,
  },
  {
    element: <Layout />,
    children: [
      {
        index: true,
        element: <MapView />,
      },
      {
        path: '/map',
        element: <MapView />,
      },
      {
        path: '/spots',
        element: <SpotListView />,
      },
      {
        path: '/spots/new',
        element: (
          <AuthGuard>
            <SpotRegistrationForm />
          </AuthGuard>
        ),
      },
      {
        path: '/spots/:id',
        element: <SpotDetailView />,
      },
      {
        path: '/spots/:id/edit',
        element: (
          <AuthGuard>
            <SpotEditForm />
          </AuthGuard>
        ),
      },
      {
        path: '/profile',
        element: (
          <AuthGuard>
            <UserProfileView />
          </AuthGuard>
        ),
      },
      {
        path: '/users/:id',
        element: <UserProfileView />,
      },
      {
        path: '/users/:id/checkins',
        element: <UserCheckinListView />,
      },
      {
        path: '/users/:id/spots',
        element: <UserSpotListView />,
      },
      {
        path: '/users/:id/followers',
        element: <FollowListView type="followers" />,
      },
      {
        path: '/users/:id/following',
        element: <FollowListView type="following" />,
      },
      {
        path: '/ranking',
        element: <RankingView />,
      },
      {
        path: '/timeline',
        element: <TimelineView />,
      },
      {
        path: '/notifications',
        element: (
          <AuthGuard>
            <NotificationsView />
          </AuthGuard>
        ),
      },
      {
        path: '/bookmarks',
        element: (
          <AuthGuard>
            <BookmarkListView />
          </AuthGuard>
        ),
      },
      {
        path: '/release-notes',
        element: <ReleaseNotesView />,
      },
      {
        path: '/help',
        element: <HelpView />,
      },
      {
        path: '/faq',
        element: <FaqView />,
      },
      {
        path: '/notification-settings',
        element: (
          <AuthGuard>
            <NotificationSettingsView />
          </AuthGuard>
        ),
      },
      {
        path: '/messages',
        element: (
          <AuthGuard>
            <InboxView />
          </AuthGuard>
        ),
      },
      {
        path: '/messages/:conversationId',
        element: (
          <AuthGuard>
            <ConversationView />
          </AuthGuard>
        ),
      },
      {
        path: '/block-list',
        element: (
          <AuthGuard>
            <BlockListView />
          </AuthGuard>
        ),
      },
    ],
  },
]);
